import {
  getEnterpriseConfig,
  SQUARESPACE_ENTERPRISE_ID
} from '#client/configs/enterprise';

// TODO: replace stub with real enterprise detection from auth claims or business entity data
// Set IS_ENTERPRISE_STUB = true to test the Squarespace enterprise experience locally
const IS_ENTERPRISE_STUB = false;

export function useEnterprise() {
  // Phase 2: read the enterprise identifier from auth,
  // then look up the matching enterprise config in ENTERPRISE_CONFIG.
  const enterprise = IS_ENTERPRISE_STUB
    ? getEnterpriseConfig(SQUARESPACE_ENTERPRISE_ID)
    : null;

  return {
    enterprise,
    loading: false
  };
}
